import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=c00d002c&scoped=true&lang=html&"
import script from "./StandardButton.vue?vue&type=script&lang=js&"
export * from "./StandardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00d002c",
  null
  
)

export default component.exports